import type {FC} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import type {RuleProvider} from '../types'
import {defaultRegistry} from './default-registry'
import type {RegisteredRuleSchemaComponent, SchemaField} from '@github-ui/repos-rules/types/rules-types'

export function RuleConfigFields({fields, provider}: {fields: SchemaField[]; provider: RuleProvider}) {
  return (
    <div>
      {fields.map(field => {
        const Component: FC<RegisteredRuleSchemaComponent> | undefined = defaultRegistry[field.type]
        const value = provider.parameters[field.name]

        if (typeof value === 'undefined') {
          return null
        }

        return Component ? (
          <ErrorBoundary key={field.name} fallback={<div>Failed to render {field.name}</div>}>
            <Component
              value={value}
              readOnly
              field={field}
              onValueChange={() => null}
              errors={[]}
              sourceType={provider.sourceType}
            />
          </ErrorBoundary>
        ) : null
      })}
    </div>
  )
}
